import styled from "styled-components";
import { SECONDARY_COLOR } from "../util/colors";
import { FONT_SMALL } from "../util/fonts";
import { MD_SCREEN} from "../util/screen-size";

export const getStyledNavBar = () => styled.div`
    position: fixed;
    display: flex;
    left: 0;
    right: 0;
    background-color: #FFFFFF;
    z-index: 10;

    @media (max-width: ${MD_SCREEN}px) {
        bottom: 0;
        background-color: ${SECONDARY_COLOR};
        padding: 0 6vw;
        height: 8vh;

        display: flex;
        justify-content: space-between;
        align-items: center;
    }

`

export const getStyledNavIcon = () => styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 1vh;
    align-items: center;
    font-size: ${FONT_SMALL};
`

export const getStyledTopNavbar = () => styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 10vh;
    margin: 0;
    z-index:10;

    width: 100vw;
    padding: 0 10vw;
`

export const getStyledTopNavItems = () => styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    column-gap: 5vw;
    font-size: 1.4em;
    height: 100%;
    
    div{
        cursor: pointer;
        height: 100%;
    }
`

export const getStyledNavActions = () => styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 2vw;
    
    svg{
        cursor: pointer;
    }
`